// NFTS
import icon_network_1 from './icons/icon_network_1.svg';
import icon_network_56 from './icons/icon_network_56.png';
import icon_network_97 from './icons/icon_network_97.png';
import icon_network_137 from './icons/icon_network_137.png';
import icon_network_4 from './icons/ic-kucoin.png';
import icon_network_43114 from './icons/icon_network_43114.png';
import icon_network_250 from './icons/icon_network_250.png';

//  BACKGROUND MODAL

import bg_modal from './bg-modal.png';

export const icon_networks = {
    icon_network_1: icon_network_1, //ether
    icon_network_56: icon_network_56, //bsc
    icon_network_97: icon_network_97, // bsc test
    icon_network_137: icon_network_137, //matic
    icon_network_43114: icon_network_43114, //avax
    icon_network_250: icon_network_250 //fantom
};

export const background_modal = {
    bg_modal: bg_modal
}